/*
 * Swipen door productfoto's in het overzicht — alleen op mobiel.
 *
 * De opmaak doet het schuiven zelf; dit script doet twee dingen:
 *  1. het laat de puntjes meelopen met de foto die in beeld staat;
 *  2. het voorkomt dat een veeg per ongeluk als tik op de link telt,
 *     zodat je niet ongewild naar de productpagina springt.
 */
(function () {
	'use strict';

	var MOBIEL = '(max-width: 1067px)';
	var media = window.matchMedia ? window.matchMedia(MOBIEL) : null;

	/*
	 * Zit er om deze kaart al iets heen dat zelf van links naar rechts
	 * schuift — een carrousel op de homepagina, een rij die op mobiel
	 * doorschuift? Dan vechten twee lagen om dezelfde veeg en schoof je de
	 * rij én de foto tegelijk op. Het thema gebruikt daar wisselende
	 * klassenamen voor, dus kijken we naar wat het werkelijk doet.
	 */
	function inSchuivendeOmgeving(element) {
		var ouder = element.parentNode;
		var stappen = 0;
		while (ouder && ouder.nodeType === 1 && ouder !== document.body && stappen < 10) {
			if (ouder.tagName === 'SLIDE-SHOW') return true;
			if (ouder.classList &&
				(ouder.classList.contains('carousel__slide') ||
				 ouder.classList.contains('carousel') ||
				 ouder.classList.contains('swipe-on-mobile'))) return true;
			var opmaak = window.getComputedStyle(ouder);
			if ((opmaak.overflowX === 'auto' || opmaak.overflowX === 'scroll') &&
				ouder.scrollWidth > ouder.clientWidth + 4) return true;
			ouder = ouder.parentNode;
			stappen++;
		}
		return false;
	}

	/*
	 * De tweede tot en met vierde foto staan klaar zonder bron, zodat ze bij
	 * het laden van de pagina niets kosten. Zodra iemand deze strook aanraakt
	 * geven we ze hun bron terug en haalt het thema ze alsnog op.
	 */
	/*
	 * Geeft één foto zijn bron terug, zodat het thema hem alsnog ophaalt.
	 *
	 * `metVoorproefje` bepaalt of we ook het kleine plaatje van twintig pixels
	 * terugzetten dat het thema normaal als wazige tussenstap gebruikt. Bij de
	 * dia's slaan we dat over: dat kost een apart verzoek voor iets dat je een
	 * halve tel ziet.
	 */
	function geefBronTerug(foto, metVoorproefje) {
		var bron = foto.getAttribute('data-pc-srcset');
		var maten = foto.getAttribute('data-pc-sizes');
		var klein = foto.getAttribute('data-pc-src');
		if (bron) {
			foto.setAttribute('data-srcset', bron);
			foto.removeAttribute('data-pc-srcset');
		}
		if (maten) {
			foto.setAttribute('data-sizes', maten);
			foto.removeAttribute('data-pc-sizes');
		}
		if (klein) {
			if (metVoorproefje) foto.setAttribute('src', klein);
			foto.removeAttribute('data-pc-src');
		}
		foto.classList.remove('pc-later');
		foto.classList.remove('pc-hover-later');
		foto.classList.add('lazyload');
	}

	// Het thema laat zijn eigen laadmechanisme opnieuw rondkijken.
	function kijkOpnieuw() {
		if (!window.lazySizes) return;
		if (window.lazySizes.loader && window.lazySizes.loader.checkElems) window.lazySizes.loader.checkElems();
		if (window.lazySizes.autoSizer && window.lazySizes.autoSizer.checkElems) window.lazySizes.autoSizer.checkElems();
	}

	function wekFotos(strook) {
		var later = strook.querySelectorAll('img.pc-later');
		if (!later.length) return;
		Array.prototype.forEach.call(later, function (foto) {
			geefBronTerug(foto, false);
		});
		kijkOpnieuw();
	}

	/*
	 * De wisselfoto voor hover heeft alleen zin op een scherm met een muis.
	 * Op een telefoon laten we hem staan waar hij staat: onopgehaald.
	 */
	function wekHoverFotos() {
		if (media && !media.matches) {
			var wachtend = document.querySelectorAll('img.pc-hover-later');
			if (!wachtend.length) return;
			Array.prototype.forEach.call(wachtend, function (foto) {
				geefBronTerug(foto, true);
			});
			kijkOpnieuw();
		}
	}

	function koppel(strook) {
		if (strook.getAttribute('data-pc-swipe-actief') === '1') return;

		if (inSchuivendeOmgeving(strook)) {
			var kaart = strook.closest('.product-card');
			if (kaart) kaart.classList.add('pc-swipe--uit');
			strook.setAttribute('data-pc-swipe-actief', 'uit');
			return;
		}

		var houder = strook.parentNode;
		if (!houder) return;

		var puntjes = houder.querySelectorAll('.pc-swipe__dot');
		if (puntjes.length < 2) return;

		strook.setAttribute('data-pc-swipe-actief', '1');

		/*
		 * De eerste twee dia's geven we hier alvast vrij — alleen op een
		 * telefoon, want daar is de strook zichtbaar.
		 *
		 * Waarom twee en niet één: de eerste veeg is verreweg de meest
		 * gemaakte, en die moet meteen goed zijn. Wachten tot de vinger het
		 * scherm raakt is dan te laat — je ziet het beeld nog inladen terwijl
		 * je al aan het vegen bent. De dia's daarna volgen wél pas bij
		 * aanraking; wie zo ver doorswipet, heeft ze intussen binnen.
		 */
		var wachtenden = strook.querySelectorAll('.pc-swipe__slide img.pc-later');
		for (var v = 0; v < Math.min(2, wachtenden.length); v++) {
			geefBronTerug(wachtenden[v], false);
		}
		if (wachtenden.length) kijkOpnieuw();

		var wacht = false;
		var laatsteVeeg = 0;
		var gewekt = false;

		function wekEenmalig() {
			if (gewekt) return;
			gewekt = true;
			wekFotos(strook);
		}

		// Zodra de vinger de strook raakt beginnen we met ophalen, nog voordat
		// de veeg klaar is.
		strook.addEventListener('touchstart', wekEenmalig, { passive: true });
		strook.addEventListener('pointerdown', wekEenmalig, { passive: true });

		strook.addEventListener('scroll', function () {
			wekEenmalig();
			laatsteVeeg = performance.now();
			if (wacht) return;
			wacht = true;
			window.requestAnimationFrame(function () {
				wacht = false;
				var breedte = strook.clientWidth || 1;
				var nu = Math.round(strook.scrollLeft / breedte);
				if (nu < 0) nu = 0;
				if (nu > puntjes.length - 1) nu = puntjes.length - 1;
				for (var n = 0; n < puntjes.length; n++) {
					if (n === nu) puntjes[n].classList.add('is-actief');
					else puntjes[n].classList.remove('is-actief');
				}
			});
		}, { passive: true });

		// Een tik binnen 250 ms na een veeg is het naijlen van die veeg,
		// geen bewuste tik op het product.
		houder.addEventListener('click', function (gebeurtenis) {
			if (performance.now() - laatsteVeeg < 250) {
				gebeurtenis.preventDefault();
				gebeurtenis.stopPropagation();
			}
		}, true);
	}

	function koppelAlles() {
		if (media && !media.matches) return;
		var stroken = document.querySelectorAll('[data-pc-swipe]');
		for (var i = 0; i < stroken.length; i++) koppel(stroken[i]);
	}

	var gepland = null;
	function koppelStraks() {
		if (gepland) return;
		gepland = window.setTimeout(function () {
			gepland = null;
			koppelAlles();
			wekHoverFotos();
		}, 150);
	}

	function start() {
		koppelAlles();
		wekHoverFotos();
	}

	start();
	document.addEventListener('DOMContentLoaded', start);
	if (media && media.addEventListener) media.addEventListener('change', start);

	// Filters en 'meer laden' plaatsen nieuwe kaarten in de pagina.
	if (window.MutationObserver && document.body) {
		new MutationObserver(koppelStraks).observe(document.body, { childList: true, subtree: true });
	}
})();
